import { useLanguage } from "../../contexts/LanguageContext";

export default function AuthFooter() {

  const { translations } = useLanguage();

  return (
    <div className="absolute bottom-0 left-0 right-0 mt-[8px]  mb-[4px] text-[8px] md:text-[11.2px] text-[#CECECE] font-public-sans text-center font-normal">
      {translations?.authFooter?.title ||
        "© 2026 Supreme Edits. All rights reserved."}
    </div>
  );
}